import Joi from 'joi-browser'

const getMailServerList = Joi.object().keys({
	properties: Joi.object()
		.keys({
			authType: Joi.string().required().valid('password', 'oauth'),
			protocol: Joi.string().required(),
			hostName: Joi.any().required(),
			queueName: Joi.string().required(),
		})
		.unknown(true),
	id: Joi.number(),
	username: Joi.string().required().allow('', null),
	tenantId: Joi.string().uuid().required(), // used as namespace in i18n // both ui appName.featureName or appModule.featureName allowed in feature
	status: Joi.string().required(),
	createdBy: Joi.string().allow(null),
	updatedBy: Joi.string().allow(null),
	createdAt: Joi.date(),
	updatedAt: Joi.date(),
	deletedSeq: Joi.number().integer(),
})
const getMailServer = Joi.object().keys({
	properties: Joi.object().keys({
		authType: Joi.string().required().valid('password', 'oauth'),
		protocol: Joi.string().required(),
		hostName: Joi.any().required(),
		portNo: Joi.number().integer(),
		timeOut: Joi.number().integer().default(10000).min(5000).allow(null),
		team: Joi.string().default('james'),
		exclusionSubject: Joi.string().default('/^((?!autoreply|ooo).)*$/g'),
		folderMapping: Joi.any().required(),
		caseFieldsMapping: Joi.any().required(),
		priorityMapping: Joi.any().required(),
		// successFolder: Joi.string().required(),
		// failedFolder: Joi.string().required(),
		// reProcessFolder: Joi.string().allow('', null),
		// domain: Joi.string().required(),
		// category: Joi.string().required(),
		// subCategory: Joi.string().required(),
		delimiter: Joi.any().default(','),
		cronPattern: Joi.string().default('*/1 * * * *'),
		moveToState: Joi.string().required(),
		multiItem: Joi.bool().default(false),
		password: Joi.string().when('authType', { is: 'password', then: Joi.optional(), otherwise: Joi.optional() }),
		// password: Joi.any().when('authType', { is: 'password', then: Joi.required(), otherwise: Joi.optional() }),
		oauth: Joi.object()
			.keys({
				redirectUri: Joi.any().when('authType', { is: 'oauth', then: Joi.required(), otherwise: Joi.optional() }),
				clientId: Joi.any().when('authType', { is: 'oauth', then: Joi.required(), otherwise: Joi.optional() }),
				clientSecret: Joi.any().when('authType', { is: 'oauth', then: Joi.required(), otherwise: Joi.optional() }),
				refreshToken: Joi.any().when('authType', { is: 'oauth', then: Joi.required(), otherwise: Joi.optional() }),
				tenantId: Joi.any().when('authType', { is: 'oauth', then: Joi.required(), otherwise: Joi.optional() }),
			})
			.when('authType', { is: 'oauth', then: Joi.required(), otherwise: Joi.optional() }),
		// exclusionFolder: Joi.string().required(),
		originalContentSplitter: Joi.string().default('appendonsend'),
		queueName: Joi.string().required(),
		aliastoemail: Joi.array().allow(null),
		exclusionAutoReplies: Joi.array().allow(null),
		allowedDomains: Joi.array().allow(null),
		maxTryTicks: Joi.number().integer().positive().default(5),
		skipTicks: Joi.number().integer().positive().default(30),
	}),
	id: Joi.number(),
	username: Joi.string().required().allow('', null),
	tenantId: Joi.string().uuid().required(), // used as namespace in i18n // both ui appName.featureName or appModule.featureName allowed in feature
	status: Joi.string().required(),
	createdBy: Joi.string().allow(null),
	updatedBy: Joi.string().allow(null),
	createdAt: Joi.date(),
	updatedAt: Joi.date(),
	deletedSeq: Joi.number().integer(),
})
const emailServer = Joi.object().keys({
	properties: Joi.object().keys({
		authType: Joi.string().required().valid('password', 'oauth'),
		protocol: Joi.string().required(),
		hostName: Joi.any().required(),
		portNo: Joi.number().integer(),
		timeOut: Joi.number().integer().default(10000).min(5000).allow(null),
		team: Joi.string().default('james'),
		exclusionSubject: Joi.string().default('/^((?!autoreply|ooo).)*$/g'),
		folderMapping: Joi.object().keys({
			SuccessFolder: Joi.string().required(),
			failedFolder: Joi.string().required(),
			exclusionFolder: Joi.string().required(),
		}),
		caseFieldsMapping: Joi.any().required(),
		priorityMapping: Joi.any().required(),
		// successFolder: Joi.string().required(),
		// failedFolder: Joi.string().required(),
		// reProcessFolder: Joi.string().allow('', null),
		// domain: Joi.string().required(),
		// category: Joi.string().required(),
		// subCategory: Joi.string().required(),
		delimiter: Joi.any().default(','),
		multiItem: Joi.bool().default(false),
		cronPattern: Joi.string().default('*/1 * * * *'),
		moveToState: Joi.string().required(),
		password: Joi.any().when('authType', { is: 'password', then: Joi.required(), otherwise: Joi.optional() }),
		oauth: Joi.object()
			.keys({
				redirectUri: Joi.any().when('authType', { is: 'oauth', then: Joi.required(), otherwise: Joi.optional() }),
				clientId: Joi.any().when('authType', { is: 'oauth', then: Joi.required(), otherwise: Joi.optional() }),
				clientSecret: Joi.any().when('authType', { is: 'oauth', then: Joi.required(), otherwise: Joi.optional() }),
				refreshToken: Joi.any().when('authType', { is: 'oauth', then: Joi.required(), otherwise: Joi.optional() }),
				tenantId: Joi.any().when('authType', { is: 'oauth', then: Joi.required(), otherwise: Joi.optional() }),
			})
			.when('authType', { is: 'oauth', then: Joi.required(), otherwise: Joi.optional() }),

		// exclusionFolder: Joi.string().required(),
		originalContentSplitter: Joi.string().default('appendonsend'),
		queueName: Joi.string().required(),
		aliastoemail: Joi.array().allow(null),
		exclusionAutoReplies: Joi.array().allow(null),
		allowedDomains: Joi.array().allow(null),
		maxTryTicks: Joi.number().integer().positive().default(5),
		skipTicks: Joi.number().integer().positive().default(30),
	}),
	id: Joi.number(),
	username: Joi.string().required(),
	tenantId: Joi.string().uuid().optional(), // used as namespace in i18n // both ui appName.featureName or appModule.featureName allowed in feature
	status: Joi.string().required(),
	createdBy: Joi.string().allow(null),
	updatedBy: Joi.string().allow(null),
	createdAt: Joi.date(),
	updatedAt: Joi.date(),
	deletedSeq: Joi.number().integer(),
})

// These are the schemas of the return object from the api server
export const methodSchemas = {
	getAll: Joi.array().items(getMailServerList),
	getOne: getMailServer,
	addItem: emailServer,
	editItem: emailServer,
	upsert: emailServer.keys({ status: Joi.string().valid('Draft', 'Deleted', 'Staging') }),
	publish: emailServer.keys({ status: Joi.string().valid('Published') }),
}
export const collectionSchemas = {
	//  notes: note
}
export const entitySchema = getMailServer
